export const DEFAULT_TASK_COLNAMES = [
    "Task_Name",
    "Task_Type",
    "Project_Name",
    "Status",
    "Help_Needed",
    "Buffer",
    "Buffer_To_Work",
    "Remaining_Work",
    "Assignee",
];

export const ALL_TASKS = "allTasks";
export const MY_TASKS = "myTasks";
export const COMPLETE = "Complete";
export const INPROGRESS = "In-Progress";

export const textAreaMaxLength = 512;
export const textFieldMaxLength = 256;
export const spcialCharAlert = "Please remove special characters"

export const LEVEL=[{LEVEL:"Low :",
DESCRIPTION:" No Color Development & print trial needed"},
{LEVEL:"Medium :",DESCRIPTION:" Color Development needed, print trial is optional"},
{LEVEL:"High :",DESCRIPTION:" Color development needed, print trial is strongly recommended"}]

export const fullkitTaskTypes = ["Confirm", "Data Check"];

export const warningMessage="If you leave this section, your changes will not be saved. Do you want to continue?";
export const confirmLeaveMessage="You have unsaved changes, are you sure you want to leave?";
export const saveWarningMessage="Please Review The Mapping and Save Before Proceeding.";
export const rejectionMessage = " Please add required details and click  ' Submit '  to complete the execution of the task before proceeding.";
export const rdtrejectMessage = "Please click 'submit' to complete the task."
export const mandatoryMissingMessage = " Please fill up all the mandatory fields and click  ' Save '  before proceeding."; //4049
export const approvalTaskSelectionMessage = "You have selected an RDT and/or CIC upload task for rework, but no approver has been assigned. Please select at least one approver and submit again.";